import { Router } from './router';
import { useEffect } from 'react';
import { useAuthStore } from './lib/auth';
import { ensureFreshSession } from './lib/sandbox';
import { SessionProvider } from './lib/session';
// GuidedTour temporarily removed (Ravi, 19 Jul) — re-mount below to re-enable.
// import { GuidedTour } from './components/ui/GuidedTour';

export default function App() {
  const { tenantSlug, hydrate } = useAuthStore();
  useEffect(() => { hydrate(); }, [hydrate]);
  // Keep the Supabase session alive so pages never silently go empty under the
  // locked RLS. Refresh on load, on a 25-min interval, AND whenever the tab
  // regains focus/visibility (timers are throttled/stopped while backgrounded
  // or asleep — the visibility hook is what catches "came back after a while").
  // If the session is truly dead (refresh token also expired), sign out so the
  // user re-authenticates instead of staring at empty screens.
  useEffect(() => {
    let cancelled = false;
    async function keepAlive() {
      // Only act when we have a session at all (skip the login screen).
      if (!useAuthStore.getState().accessToken) return;
      const ok = await ensureFreshSession();
      if (!cancelled && !ok) useAuthStore.getState().signOut(); // RequireAuth then redirects to login
    }
    keepAlive();
    const id = setInterval(keepAlive, 25 * 60 * 1000);
    const onVisible = () => { if (document.visibilityState === 'visible') keepAlive(); };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, []);
  useEffect(() => {
    if (tenantSlug) document.documentElement.setAttribute('data-tenant', tenantSlug);
    else document.documentElement.removeAttribute('data-tenant');
  }, [tenantSlug]);
  return <SessionProvider><Router /></SessionProvider>;
}
